export default __webpack_public_path__ + "static/media/S-002.7038b7ca.png";